import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown, DropdownMenu, DropdownToggle, UncontrolledTooltip } from 'reactstrap';
import { Bell, Eye, EyeOff } from 'react-feather';

import PerfectScrollbar from 'react-perfect-scrollbar';

import 'react-perfect-scrollbar/dist/css/styles.css';

const notificationContainerStyle = {
    maxHeight: '230px',
};

class NotificationDropdown extends Component {
    static defaultProps = {
        notifications: [],
    };

    constructor(props) {
        super(props);
        this.toggleDropdown = this.toggleDropdown.bind(this);

        this.state = {
            dropdownOpen: false,
            markAsRead: false,
        };
    }

    /*:: toggleDropdown: () => void */
    toggleDropdown() {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen,
        });
    }
    toggleRead() {
        this.setState({
            markAsRead: !this.state.markAsRead,
        });
    }

    getRedirectUrl = (item) => {
        return `/notification/${item.id}`;
    };

    render() {
        const tag = this.props.tag || 'div';

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleDropdown} className="notification-list" tag={tag}>
                    <DropdownToggle
                        data-toggle="dropdown"
                        tag="a"
                        className="nav-link dropdown-toggle mt-2"
                        onClick={this.toggleDropdown}
                        aria-expanded={this.state.dropdownOpen}
                        id="notiDropdown"
                    >
                        <Bell />
                        <span className="noti-icon-badge"></span>
                    </DropdownToggle>
                    <DropdownMenu right className="dropdown-lg">
                        <div>
                            <div className="dropdown-item noti-title border-bottom">
                                <h5 className="m-0 font-size-16">
                                    <span className="float-right">
                                        <button type='button'>
                                            <small>Clear All</small>
                                        </button>
                                        {/* <Link to="/notifications" className="text-dark"> */}
                                        {/* </Link> */}
                                    </span>
                                    Notification
                                </h5>
                            </div>
                            <PerfectScrollbar style={notificationContainerStyle}>
                                {this.props.notifications.map((item, i) => {
                                    return (
                                        <div className="d-flex">
                                            <Link to={this.getRedirectUrl(item)} className="dropdown-item notify-item" key={i + '-noti'}>
                                                <div className={`notify-icon bg-${item.bgColor}`}>
                                                    <i className={item.icon}></i>
                                                </div>
                                                <p style={!this.state.markAsRead ? { fontWeight: 'bold' } : {}} className="notify-details">
                                                    {item.text}
                                                    <small className="text-muted">{item.subText}</small>
                                                </p>
                                            </Link>
                                            <button type="button" onClick={() => this.toggleRead()}>
                                                {this.state.markAsRead ? (
                                                    <Eye height={20} width={30} color="grey" />
                                                ) : (
                                                    <EyeOff height={20} width={30} color="grey" />
                                                )}
                                            </button>
                                        </div>
                                    );
                                })}
                            </PerfectScrollbar>

                            <Link to="/" className="dropdown-item text-center text-primary notify-item notify-all border-top">
                                View All
                            </Link>
                        </div>
                    </DropdownMenu>
                </Dropdown>

                <UncontrolledTooltip placement="left" target="notiDropdown">
                    {this.props.notifications.length} new unread notificationse
                </UncontrolledTooltip>
            </React.Fragment>
        );
    }
}

export default NotificationDropdown;
